import HeaderArrowLeftWhite from './header/arrow_left_white.svg'
import ActiveNote from './note/active_note.svg'
import RecipeSelectByImage from './recipe/select_by_image.svg'
import RecipeSelectByList from './recipe/select_by_list.svg'
import RecipeSelectImageByCamera from './recipe/select_image_by_camera.svg'
import RecipeSelectImageByGallery from './recipe/select_image_by_gallery.svg'
import RecipeRemove from './recipe/remove.svg'
import RecipeSearch from './recipe/search.svg'
import RecipePlus from './recipe/plus.svg'
import RecipeMinus from './recipe/minus.svg'
import RecipeTime from './recipe/time.svg'
import RecipeAiLoading from './recipe/loading.gif'
import RecipeAiLoadingSpin from './recipe/loading-spin.gif'
import RecipeUploading from './recipe/uploading.svg'
import RecipeCalories from './recipe/calories.svg'
import VideoPlay from './video/play_video.svg'
import VideoPause from './video/icons8-pause-24.png'
import VideoNext10 from './video/next10.svg'
import VideoPrev10 from './video/prev10.svg'
import VideoRemove from './video/remove.svg'
import VideoMute from './video/mute-svgrepo-com.svg'
import VideoUnmute from './video/volume-off-svgrepo-com.svg'
import VideoMiniPlayer from './video/noun-6357400.svg'
import VideoFullPlayer from './video/noun-6357415.svg'
import BottomAiChef from './bottom_nav/ai_chef_active.svg'
import NoImage from './no_image.svg'
import Apple from './login/apple_small.svg';
import Facebook from './login/fb_small.svg';
import Google from './login/google_small.svg';
import ID from './login/id.svg';
import Password from './login/password.svg';
import Region from './login/region.svg';
import Gmail from './login/gmail_small.svg';
import CopyShare from './recipe/social/icon_copy.svg';
import FbShare from './recipe/social/icon_fb.svg';
import InstagramShare from './recipe/social/icon_instagram.svg';
import KakaoShare from './recipe/social/icon_kakao.svg';
import MoreShare from './recipe/social/icon_more.svg';
import InAppShare from './recipe/social/icon_social_app.svg';
import IconClean from './recipe/icon_clean.svg';
import IconFire from './recipe/icon_fire.svg';
import IconClock from './recipe/icon_clock.svg';
import IconSearching from './recipe/icon_searching.svg';
import IconUnHappy from './recipe/icon_not_found.svg';
import Close from './commons/icon_close.svg';
import CloseWhite from './commons/icon_close_white.svg';
import CloseRounded from './comunity/close_rounded.svg';
import TickWhite from './commons/icon_tick_white.svg';
import ImagePlus from './comunity/image_plus.svg';
import CommunityPlusIcon from './comunity/plus.svg';
import Heart from './comunity/icon_heart.svg';
import HeartActive from './comunity/icon_heart_active.svg';
import HeartView from './comunity/icon_heart_view.svg';
import SettingDropDown from './comunity/icon_setting.svg';
import SharePost from './comunity/icon_share_post.svg';
import SharePostWhite from './comunity/icon_share_post_white.svg';
import Follwed from './comunity/personal-channel/followed_user.svg';
import FollwedSmall from './comunity/personal-channel/followed_user_small.svg';
import AddFollow from './comunity/personal-channel/add_follow_user.svg';
import AddFollowSmall from './comunity/personal-channel/add_follow_user_small.svg';
import EditUser from './comunity/personal-channel/edit_user.svg';
import UserFollow from './comunity/personal-channel/user_follow.svg';
import AvatarBigDefault from './comunity/personal-channel/avatar_big_default.svg';
import Comment from './comunity/icon_comment.svg';

const Icon = {
  HeaderArrowLeftWhite,
  ActiveNote,
  RecipeSelectByImage,
  RecipeSelectByList,
  RecipeSelectImageByCamera,
  RecipeSelectImageByGallery,
  RecipeRemove,
  RecipeSearch,
  RecipePlus,
  RecipeMinus,
  RecipeTime,
  RecipeUploading,
  RecipeAiLoading,
  RecipeAiLoadingSpin,
  RecipeCalories,
  VideoPlay,
  VideoPause,
  VideoNext10,
  VideoPrev10,
  VideoRemove,
  VideoMute,
  VideoUnmute,
  VideoMiniPlayer,
  VideoFullPlayer,
  BottomAiChef,
  NoImage,
  Apple,
  Facebook,
  Google,
  ID,
  Password,
  Region,
  Gmail,
  CopyShare,
  FbShare,
  InstagramShare,
  KakaoShare,
  MoreShare,
  InAppShare,
  IconClean,
  IconFire,
  IconClock,
  IconSearching,
  IconUnHappy,
  Close,
  CloseWhite,
  CloseRounded,
  TickWhite,
  ImagePlus,
  CommunityPlusIcon,
  Heart,
  HeartActive,
  HeartView,
  SettingDropDown,
  SharePost,
  SharePostWhite,
  Follwed,
  FollwedSmall,
  AddFollow,
  AddFollowSmall,
  EditUser,
  UserFollow,
  AvatarBigDefault,
  Comment
}

export {
  HeaderArrowLeftWhite,
  ActiveNote,
  RecipeSelectByImage,
  RecipeSelectByList,
  RecipeSelectImageByCamera,
  RecipeSelectImageByGallery,
  RecipeRemove,
  RecipeSearch,
  RecipePlus,
  RecipeMinus,
  RecipeTime,
  RecipeUploading,
  RecipeAiLoading,
  RecipeAiLoadingSpin,
  RecipeCalories,
  VideoPlay,
  VideoPause,
  VideoNext10,
  VideoPrev10,
  VideoRemove,
  VideoMute,
  VideoUnmute,
  VideoMiniPlayer,
  VideoFullPlayer,
  BottomAiChef,
  NoImage,
  Apple,
  Facebook,
  Google,
  ID,
  Password,
  Region,
  Gmail,
  CopyShare,
  FbShare,
  InstagramShare,
  KakaoShare,
  MoreShare,
  InAppShare,
  IconClean,
  IconFire,
  IconClock,
  IconSearching,
  IconUnHappy,
  Close,
  CloseWhite,
  CloseRounded,
  TickWhite,
  ImagePlus,
  CommunityPlusIcon,
  Heart,
  HeartActive,
  HeartView,
  SettingDropDown,
  SharePost,
  SharePostWhite,
  Follwed,
  FollwedSmall,
  AddFollow,
  AddFollowSmall,
  EditUser,
  UserFollow,
  AvatarBigDefault,
  Comment
}
export default Icon
